import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Pagination } from '@mui/material';
import axios from '../../shared/axiosConfig';
import AddIcon from '@mui/icons-material/Add';
import { Investor, InvestorPayouts, PaginatedResponse } from '../../shared/models';
import InvestorPayoutsForm from './InvestorPayoutsForm';
import CurrencyAmount from '../../shared/components/CurrencyAmount';
import { SnackbarSeverity, useSnackbar } from '../../shared/services/SnackbarService';
import { useAuth } from '../../shared/context/AuthContext';
import DateTimeValue from '../../shared/components/DateTimeValue';

const OwnerPayoutsList: React.FC = () => {
    const { userDetails } = useAuth();
    const [payouts, setPayouts] = useState<InvestorPayouts[]>([]);
    
    const [open, setOpen] = useState<boolean>(false);
    const [payoutsPaidAmount, setPayoutsPaidAmount] = useState<any>();
    const [search, setSearch] = useState<string>('');
    const [editing, setEditing] = useState<InvestorPayouts | null>(null);

    const [loading, setLoading] = useState<boolean>(true);
    const { showSnackbar } = useSnackbar();
    const [page, setPage] = useState<number>(1);
    const [rowsPerPage] = useState<number>(9); // Number of restaurants per page
    const [totalPages, setTotalPages] = useState<number>();

    useEffect(() => {
        fetchPayouts();
        fetchPayoutsPendingAmount();
    }, []);

    

    const fetchPayouts = async () => {
        try {
            let url = 'business-payouts/';
            setLoading(true);
            const response = await axios.get<PaginatedResponse<InvestorPayouts>>(url, {
                params: {
                    page: page,
                    page_size: rowsPerPage
                }
            });
            setPayouts(response.data.results);
            setTotalPages(Math.ceil(response.data.count/rowsPerPage));
        } catch (error) {
            console.error("Failed to fetch Payouts", error);
            showSnackbar("Failed to fetch Payouts. Please try again.", SnackbarSeverity.ERROR);
        } finally {
            setLoading(false);
        }
    };
    const fetchPayoutsPendingAmount = async () => {
        const response = await axios.get<any>('business-payouts/paid_amount/');
        setPayoutsPaidAmount(response.data);
    };

    const handleEdit = (payout: any) => {
        setEditing(payout);
        setOpen(true);
    };
    const handleAdd = () => {
        setEditing(null);
        setOpen(true);
    };

    const onClose = () => { 
        setEditing(null); 
        setOpen(false);
        fetchPayouts(); 
    }

    return (
        <div>
            <h2>Paid Payouts</h2>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div>
                    <h4>Total Paid - <CurrencyAmount amount={payoutsPaidAmount} /></h4>
                </div>
                
            </div>
                
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Investor</TableCell>
                            <TableCell>Payout Amount</TableCell>
                            <TableCell>Payout Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payouts.map((payout, index) => (
                            <TableRow key={payout.id}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{payout.investor.first_name} {payout.investor.last_name}</TableCell>
                                <TableCell><CurrencyAmount amount={payout.payout_amount} /></TableCell>
                                <TableCell><DateTimeValue value={payout.payout_date} /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    variant="outlined"
                    shape="rounded"
                    style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}

                />
            <InvestorPayoutsForm open={open} payout={editing} onClose={onClose} />
        </div>
    );
};

export default OwnerPayoutsList;